/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, OnInit, Input } from '@angular/core';

import { WorkflowNode } from "../../../models/workflow-node";
import { WorkflowServiceNode } from "../../../models/workflow-service-node";
import { WorkflowNodeData } from "../../../models/workflow-node-data";
import { Operator } from '../../../models/workflow-operator';
import { Function } from "../../../models/function";
import { Service } from "../../../models/service";
import { ServiceInstance } from "../../../models/service-instance";

import { ServiceService } from "../../../services/service.service";

@Component({
  selector: 'app-workflow-service-node',
  templateUrl: './workflow-service-node.component.html'
})
export class WorkflowServiceNodeComponent implements OnInit {

    @Input()
    node: WorkflowServiceNode;
    
    service: ServiceInstance;
    serviceFunction: Function;
    serviceData: WorkflowNodeData;

    services: ServiceInstance[];
    serviceFunctions: Function[];

    constructor(private serviceService: ServiceService) { }
    
    ngOnInit() {
        console.log("WorkflowServiceNodeComponent - ngOnInit: " + this.node.service);
//        this.service = this.node.service;
        //this.getServices();
        this.loadServices();

        if (this.node != null && this.node.serviceFunction != null) {
            this.loadServiceFunctions();
        }
    }

    onSelectService(): void {
        console.log(this.node.service);
        this.loadServiceFunctions();
    }

    async loadServiceFunctions(): Promise<void> {
        const serviceInstance = await this.serviceService.getServiceInstanceById(this.node.service.id);
        this.serviceFunctions = serviceInstance.service.functions;

        if (this.node != null && this.node.serviceFunction != null) {
            this.serviceFunction = this.serviceFunctions.find(fn => fn.id == this.node.serviceFunction.id);
        }
    }

    onSelectServiceFunction(): void {
        console.log(this.node.serviceFunction);
        this.node.data = [];

        for (const parameter of this.serviceFunction.parameters) {
            const nodeDatum = new WorkflowNodeData();
            nodeDatum.property = parameter.key;
            nodeDatum.operator = Operator.EQUAL;
            nodeDatum.value = "";
            
            this.node.data.push(nodeDatum);
        }
    }

    async loadServices(): Promise<void> {
        const services: ServiceInstance[] = await this.serviceService.getAllServiceInstances();
        this.services = services;

        if (this.node != null && this.node.service != null) {
            this.service = this.services.find(fn => fn.id == this.node.service.id);
        }
    }

    private getServices(): void {
        const services: ServiceInstance[] = [];
        this.serviceService.getAllServiceInstances().then(
            response => {
                for (const service of response) {
                    services.push(service);
                }

                this.services = services;
            },
            error => {
                console.error('WorkflowServiceNodeComponent: ', error);
            }
        );
    }
}
